<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="下次执行日期" prop="deferralTime">
              <!-- <a-input placeholder="请输入文档名称" v-model="model.deferralTime"></a-input> -->
              <j-date class="w-full" v-model="model.deferralTime"></j-date>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import moment from 'moment'
export default {
  name: 'DevDocsForm',
  components: {},
  props: {
    // 表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    deviceData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {
        deferralTime: [{ required: true, message: '请选择下次执行日期!' }]
      },
      url: {
        edit: '/maintenance/devMaintainceTask/taskExtension'
      },
      deviceList: []
    }
  },

  computed: {
    formDisabled() {
      return this.disabled
    }
  },
  created() {
    // 备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))
    // getAction(this.url.getDeviceSelect).then(res => {
    //   this.deviceList = res.result.records
    // })
  },
  methods: {
    add(device) {
      //
      const { id, devTypeId = '' } = device

      // if (devTypeId) {
      //   this.modelDefault.devModelId = devTypeId
      // } else {
      //   this.modelDefault.devId = id
      // }

      this.edit(this.modelDefault)
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.model.deferralTime = moment()
        .add(1, 'months')
        .format('YYYY-MM-DD')
      this.visible = true
    },
    submitForm() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = this.url.edit
          let method = 'get'

          getAction(httpurl, { id: this.model.id, deferralTime: this.model.deferralTime })
            .then(res => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>
